// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useState } from "react";
import { css } from "styled-components";

const wrapperCss = css`
    ${clearfixStyles()}
    max-width: 600px;
`;

const contentCss = css`
    display: flex;
    gap: 10px;
    flex-flow: row wrap;
    flex: 1 0 100%;
`;

const itemCss = css`
    display: flex;
`;

const StyleguideInfosBox: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Infos Box" sectionId={sectionId}>
            <StyledWrapper css={wrapperCss}>
                <StyledWrapper css={contentCss}>
                    <StyledWrapper css={itemCss}>
                        <InfosBox type="info">Pellentesque commodo porta velit, ut consequat diam feugiat eu</InfosBox>
                    </StyledWrapper>
                    <StyledWrapper css={itemCss}>
                        <InfosBox type="success">
                            Pellentesque commodo porta velit, ut consequat diam feugiat eu
                        </InfosBox>
                    </StyledWrapper>
                    <StyledWrapper css={itemCss}>
                        <InfosBox type="warning">
                            Pellentesque commodo porta velit, ut consequat diam feugiat eu
                        </InfosBox>
                    </StyledWrapper>
                    <StyledWrapper css={itemCss}>
                        <InfosBox type="error">Pellentesque commodo porta velit, ut consequat diam feugiat eu</InfosBox>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyleguideSection>
    );
};

export default StyleguideInfosBox;
